export const traderNameErrorText = 'Начинается с a-z, 3–256 символов. Разрешены: строчные буквы, цифры, _';
export const traderNameRegex = /^[a-z][a-z0-9_]{2,255}$/;
